var captchaCallBackMap={successCb:[],errorCb:[]// closeCb: [], // 不需要多次执行
// feedbackSubmitCb: [], // 不需要多次执行
};/**
 * 背景：业务会在同一个场景同时调用多次 render 函数,这些render 函数分别传入不同的 successCb ，
 * 之前验证码的处理方式是调用 render 时会覆盖掉 init 中的回调函数，
 * 且同时调用只会渲染一次验证码，验证码成功失败也只会调用一次回调函数（最后一次 render 传入的回调函数），
 * 这种情况下业务就会有部分回调不执行的情况，就可能影响业务的逻辑。
 *
 * 现在修改逻辑为：每次调用 render 函数，会覆盖配置化的参数，
 * 但回调参数不会覆盖 init 传入的回调函数，
 * 每次调用 render 会 push 一个回调函数进入 captchaCallBackMap 中，
 * 在执行回调时，会依次执行 captchaCallBackMap 中的回调，并在调用后清空
 */ /**
 * 按照 push 进数组的顺序调用 Cb
 */export function handlerCallBack(cbName,theArg){if(!captchaCallBackMap[cbName].length)return false;captchaCallBackMap[cbName].forEach(function(cb){cb(theArg);});// captchaCallBackMap[cbName] = [];
if(cbName==='successCb'){clearCallBack();}return true;}/**
 * 将 captchaOptions 中要处理的 callBack push 到对应的数组中
 * 并从 captchaOptions 剔除掉对应的 callBack 参数
 */export function saveCallBack(captchaOptions){clearCallBack();if(typeof(captchaOptions===null||captchaOptions===void 0?void 0:captchaOptions.successCb)==='function'){captchaCallBackMap.successCb.push(captchaOptions.successCb);}if(typeof(captchaOptions===null||captchaOptions===void 0?void 0:captchaOptions.errorCb)==='function'){captchaCallBackMap.errorCb.push(captchaOptions.errorCb);}}/**
 * 关闭验证码弹窗时，需要手动清除一次回调队列中的函数，避免二次弹起时多次调用回调导致错误
 */export function clearCallBack(){captchaCallBackMap['successCb']=[];captchaCallBackMap['errorCb']=[];}